__turbopack_context__.v({
  "buttonStack": "Landing-module-scss-module__rC_FWq__buttonStack",
  "description": "Landing-module-scss-module__rC_FWq__description",
  "greeting": "Landing-module-scss-module__rC_FWq__greeting",
  "headline": "Landing-module-scss-module__rC_FWq__headline",
  "name": "Landing-module-scss-module__rC_FWq__name",
});
